// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/contratti/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","numero":"string","stato":"string","descrizione":"string","dataInizio":"string","dataFine":"string","periodicita":"string","modalitaPagamento":"string","ordine":{"id":"number","numero":"string"},"commessa":{"id":"number","numero":"string"},"log":"array"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
